import 'dayjs/locale/it'
import dayjs from 'dayjs'

dayjs.locale('it')

export const DayJs = dayjs
